import { useEffect, useState } from 'react';

import isLandscape from '@/utils/helpers/is-landscape';

const MOBILE_BREAKPOINT = 1024;

const useMobileLandscape = (): boolean => {
  const [isMobileLandscape, setIsMobileLandscape] = useState<boolean>(false);

  useEffect(() => {
    const update = () => {
      setIsMobileLandscape(window.innerWidth <= MOBILE_BREAKPOINT && isLandscape());
    };

    update();

    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);

    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);

  return isMobileLandscape;
};

export default useMobileLandscape;
